module.exports = __webpack_public_path__ + "2649533e1d44a2ef75d5679ef6839b9e.svg";